
  document.addEventListener("DOMContentLoaded", () => {
    /* ----------------------------------------
      Toggle collection description (smooth + text switch)
    ---------------------------------------- */
    const wrap = document.getElementById("collection-desc");
    const btn = document.getElementById("toggle-desc");
    const content = document.getElementById("collection-desc-content");
    const label = btn?.querySelector(".btn-read-more__label");

    if (wrap && btn && content && label) {
      const moreText = btn.dataset.more || "Läs mer";
      const lessText = btn.dataset.less || "Läs mindre";

      // initial state (collapsed)
      wrap.setAttribute("data-collapsed", "true");
      btn.setAttribute("aria-expanded", "false");
      content.setAttribute("aria-hidden", "true");
      label.textContent = moreText;
      content.style.maxHeight = "0px";

      function openDesc() {
        wrap.setAttribute("data-collapsed", "false");
        btn.setAttribute("aria-expanded", "true");
        content.setAttribute("aria-hidden", "false");
        btn.classList.add("is-open");
        label.textContent = lessText;

        // Sätt korrekt höjd för mjuk expand
        content.style.maxHeight = content.scrollHeight + "px";
      }

      function closeDesc() {
        // För att få snygg collapse: sätt aktuell höjd först -> sen 0
        content.style.maxHeight = content.scrollHeight + "px";
        requestAnimationFrame(() => {
          content.style.maxHeight = "0px";
        });

        wrap.setAttribute("data-collapsed", "true");
        btn.setAttribute("aria-expanded", "false");
        content.setAttribute("aria-hidden", "true");
        btn.classList.remove("is-open");
        label.textContent = moreText;
      }

      btn.addEventListener("click", () => {
        const collapsed = wrap.getAttribute("data-collapsed") === "true";
        collapsed ? openDesc() : closeDesc();
      });

      // Om innehåll ändrar höjd (fonts/bilder) medan den är öppen
      window.addEventListener("resize", () => {
        if (wrap.getAttribute("data-collapsed") === "false") {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }

    /* ----------------------------------------
      Subcategory scroller
    ---------------------------------------- */
    const scroller = document.getElementById("subcategoryScroller");
    const btnLeft = document.querySelector(".subcategory-scroll-btn--left");
    const btnRight = document.querySelector(".subcategory-scroll-btn--right");

    if (scroller && btnLeft && btnRight) {
      const scrollAmount = 300;

      btnLeft.addEventListener("click", () => {
        scroller.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      });

      btnRight.addEventListener("click", () => {
        scroller.scrollBy({ left: scrollAmount, behavior: "smooth" });
      });

      const updateVisibility = () => {
        if (window.innerWidth < 768) {
          const overflow = scroller.scrollWidth > scroller.clientWidth;
          btnLeft.style.display = overflow ? "flex" : "none";
          btnRight.style.display = overflow ? "flex" : "none";
        } else {
          btnLeft.style.display = "none";
          btnRight.style.display = "none";
        }
      };

      updateVisibility();
      window.addEventListener("resize", updateVisibility);
    }
  });

  /* ----------------------------------------
    Facet filter count update (keep separate event)
  ---------------------------------------- */
  document.addEventListener("on:facet-filters:updated", async function () {
    try {
      const productCountElement = document.getElementById("collection-product-count");
      if (!productCountElement) return;

      const sectionElement = document.getElementById("product-count-section");
      const sectionId = sectionElement ? sectionElement.dataset.sectionId : null;
      if (!sectionId) return;

      const url = new URL(window.location.href);
      url.searchParams.set("section_id", sectionId);

      const response = await fetch(url.toString());
      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const updatedCountElement = doc.getElementById("collection-product-count");
      if (updatedCountElement) {
        productCountElement.innerHTML = updatedCountElement.innerHTML;
      }
    } catch (error) {
      console.warn("Error updating product count:", error);
    }
  });
